import { render, staticRenderFns } from "./ListSortToggler.vue?vue&type=template&id=570c04a1&"
import script from "./ListSortToggler.vue?vue&type=script&lang=js&"
export * from "./ListSortToggler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports